import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const siteName = import.meta.env.VITE_SITE_NAME || 'Cripto News';

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">{siteName}</h3>
            <p className="text-sm mb-3">
              Seu portal de notícias sobre criptomoedas em português. Curadoria diária das principais fontes do mercado cripto para o leitor brasileiro.
            </p>
            <p className="text-xs text-gray-500">
              Responsável: Gabriel Leite Moreira<br />
              Blumenau, SC, Brasil<br />
              <a href="mailto:contact@criptonews.site" className="hover:text-gray-300 transition">
                contact@criptonews.site
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Links Rápidos</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/trending" className="hover:text-white transition">
                  Em Alta
                </Link>
              </li>
              <li>
                <Link to="/aprenda" className="hover:text-white transition">
                  Aprenda
                </Link>
              </li>
              <li>
                <Link to="/glossario" className="hover:text-white transition">
                  Glossário Cripto
                </Link>
              </li>
              <li>
                <Link to="/ferramentas" className="hover:text-white transition">
                  Ferramentas
                </Link>
              </li>
              <li>
                <Link to="/resumo-diario" className="hover:text-white transition">
                  Resumo Diário
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="hover:text-white transition">
                  Sobre
                </Link>
              </li>
              <li>
                <Link to="/autores" className="hover:text-white transition">
                  Autores
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition">
                  Contato
                </Link>
              </li>
            </ul>
          </div>

          {/* Sources */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Nossas Fontes</h3>
            <ul className="space-y-2 text-sm">
              <li>CoinDesk</li>
              <li>CoinTelegraph</li>
              <li>Bitcoin.com</li>
              <li>CryptoSlate</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-sm space-y-2">
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-1">
            <Link to="/politica-de-privacidade" className="hover:text-white transition">
              Política de Privacidade
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/termos-de-uso" className="hover:text-white transition">
              Termos de Uso
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/contact" className="hover:text-white transition">
              Contato
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/sobre" className="hover:text-white transition">
              Sobre
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/politica-editorial" className="hover:text-white transition">
              Política Editorial
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/politica-de-correcoes" className="hover:text-white transition">
              Correções
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/glossario" className="hover:text-white transition">
              Glossário
            </Link>
          </div>
          <p className="text-gray-500">
            © {currentYear} {siteName}. Todos os direitos reservados. Notícias agregadas de fontes públicas.
            O conteúdo pertence aos respectivos editores.
          </p>
          <p className="text-gray-600 text-xs">
            Este site não oferece aconselhamento financeiro ou de investimento. Investimentos em criptomoedas envolvem alto risco e volatilidade.
          </p>
        </div>
      </div>
    </footer>
  );
};
